﻿(function() {
    const widgetSelector = '.reeview-app-widget';
    const slideSelector = '.keen-slider__slide';
    const titleSelector = '.vw-cmp__in-video-card--title';
    const previewSelector = 'div.vw-cmp__in-video-card--preview';
    const productNameSelector = '.product__title h1';

    function pushVideoCardClick(videoCard) {
        const videoTitleEl = videoCard.querySelector(titleSelector);
        const previewEl = videoCard.querySelector(previewSelector);
        const productNameEl = document.querySelector(productNameSelector);

        if (!videoTitleEl || !previewEl || !productNameEl) {
            return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'video_card_click',
            video_block: 'lifestyle_videos',
            video_card_title: videoTitleEl.textContent.trim(),
            video_card_position: previewEl.getAttribute('aria-label'),
            product_name: productNameEl.textContent.trim(),
            page_location: window.location.href
        });
    }

    function attachListeners() {
        const host = document.querySelector(widgetSelector);
        if (!host || !host.shadowRoot) {
            return false;
        }

        const videoCards = host.shadowRoot.querySelectorAll(slideSelector);
        if (!videoCards.length) {
            return false;
        }

        videoCards.forEach((videoCard) => {
            if (!videoCard.dataset.gtmListenerAttached) {
                videoCard.addEventListener('click', () => pushVideoCardClick(videoCard));
                videoCard.dataset.gtmListenerAttached = '1';
            }
        });

        return true;
    }

    function init() {
        if (attachListeners()) {
            return;
        }

        const observer = new MutationObserver(() => {
            if (attachListeners()) {
                observer.disconnect();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
